import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetConfigurationDictionariesQuery } from '../../store/dictionaries/service';

import { CurrenciesRoutes } from '../../routes';

import cn from './currencies.module.css';

const Currencies = (): React.JSX.Element => {
  const navigate = useNavigate();
  const match = useMatch(CurrenciesRoutes.CURRENCIES);

  const { activePermissions, riskScoreRanges } = useAppSelector(
    (state) => state.configurationDictionaries,
  );

  const [getDictionaries] = useLazyGetConfigurationDictionariesQuery();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.SECTION_EXCHANGE_SETTINGS)
    ) {
      if (!riskScoreRanges) {
        getDictionaries();
      }

      if (activePermissions.includes(PermissionEnum.SETTINGS_CURRENCIES_LIST)) {
        if (match) {
          navigate(CurrenciesRoutes.CURRENCIES_LIST);
        }
      }
    }
  }, [match, activePermissions, riskScoreRanges]);

  useEffect(() => {
    let title = 'Currencies';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.currenciesLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_EXCHANGE_SETTINGS) ||
      !activePermissions.includes(PermissionEnum.SETTINGS_CURRENCIES_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.currencies}>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default Currencies;
